export const getIconPath = (iconName: string) => require(`../../../../assets/icons/${iconName}`);
